import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const StyledPillPickerEditorWrapper = styled.div`
  .pill-picker-editor--disabled {
    .editor {
      background-color: ${GrayColors["G-0-5"]};
      color: ${GrayColors["G-4"]};
    }
  }
  .is-active {
    .empty-node {
      visibility: visible;
    }
  }

  .is-default {
    .empty-node {
      visibility: hidden;
    }
  }

  .grow-extra-long-editor {
    .ProseMirror {
      min-height: 200px;
      max-height: initial;
      padding: 7px 8px;

      p {
        line-height: 25px;
        vertical-align: middle;
      }

      .pill-node-view-wrapper {
        margin-left: 4px;
        margin-right: 0px;
        display: inline-flex;
        max-width: 100%;
        margin-right: 0px;
        vertical-align: middle;

        .field-type-pill {
          max-width: 100%;
          margin: 0 4px 0 0;
          position: relative;
          top: -1px;
        }
      }
    }
  }

  .grow-long-editor {
    .ProseMirror {
      min-height: 55px;
      max-height: initial;
    }
  }

  .editor.pill-picker-editor {
    &__editor {
      width: 100%;
      padding-right: 30px;
      padding-left: 10px;

      .pill-node-view-wrapper {
        margin-left: 4px;
        margin-right: 0px;
        display: inline-flex;
        max-width: 100%;
        margin-right: 6px;
        vertical-align: bottom;
      }

      & > div.ProseMirror[contenteditable] {
        min-height: initial;
        max-height: initial;
        padding: 5px 0;
      }
    }
  }
  .empty-node:before {
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    color: ${GrayColors["G-4"]};
    white-space: nowrap;
  }
  .editor.pill-picker-editor__editor > .ProseMirror[contenteditable] {
    .field-type-pill {
      max-width: 100%;
      margin: 0 4px 0 0;
      position: relative;
      top: -1px;

      // TODO: Remove after deploy updates to smartdoc repository
      .text {
        font-size: 13px;
        line-height: 18px;
      }
    }

    min-width: 100px !important;
    font-size: 13px !important;
    padding: 3px 0 0 0;

    p {
      line-height: 24px;
    }
  }
`;
